import { useState } from "react";
import { Link } from "react-router-dom";
import CareerListItem from "../ListItems/CareerListItem";
import BreadCrumb from "../Controls/BreadCrumb";
import UserData from "../Controls/UserData";
import Help from "../Controls/Help";
import { MdAddBox } from "react-icons/md";
import "../../style/scss/form.scss";
import "../../style/scss/CustomButton.scss";

export default function Careers() {
  const [userData] = useState(UserData.UserData());
  const careers = userData.careers || [];

  return (
    <div className="pagebody">
      <BreadCrumb props={["Careers"]} />
      <div className="tabbody">
        <div className="listTitle">
          <h2>Careers</h2>
          <div className="listTitleIcons">
            <Link to="/careers/0" title="Add career">
              <MdAddBox />
            </Link>
          </div>
        </div>
        <Help id="2137" />
        {careers.length === 0 ? (
          <p>
            You have not entered any careers yet.{" "}
            <Link to="/careers/0">Create your first career</Link> so matching can find you.
          </p>
        ) : (
          <ul className="SkillList">
            {careers.map((career) => {
              return <CareerListItem key={career.ID || career.id} career={career} />;
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
